const NoMoreData = () => {
  return (
    <div className='card d-flex w-50 justify-content-center align-items-center mx-auto my-5 p-5'>
        <h1 className='display-1 text-danger'>No More Data</h1>
    </div>
  )
}

export default NoMoreData